<template>
  <div :class="clases_contenedor">
    <!-- STEPPER: Búsqueda > Local > Agenda -->
    <div class="flex items-center justify-center gap-4">
      <!-- Paso 1: Búsqueda (activo) -->
      <div
        class="w-[75px] h-[64px] rounded-2xl border-2 border-VERDE_TOP_CALIDAD bg-white flex flex-col items-center justify-center"
      >
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="text-[#1C1B1F]"
        >
          <path
            d="M11.25 20C13.6667 20 15.7292 19.151 17.4375 17.4531C19.1458 15.7552 20 13.6875 20 11.25C20 8.83333 19.1458 6.77083 17.4375 5.0625C15.7292 3.35417 13.6667 2.5 11.25 2.5C8.8125 2.5 6.74479 3.35417 5.04688 5.0625C3.34896 6.77083 2.5 8.83333 2.5 11.25C2.5 13.6875 3.34896 15.7552 5.04688 17.4531C6.74479 19.151 8.8125 20 11.25 20ZM11.25 14.375C12.125 14.375 12.8646 14.0781 13.4688 13.4844C14.0729 12.8906 14.375 12.1458 14.375 11.25C14.375 10.375 14.0729 9.63542 13.4688 9.03125C12.8646 8.42708 12.125 8.125 11.25 8.125C10.3542 8.125 9.60938 8.42708 9.01562 9.03125C8.42188 9.63542 8.125 10.375 8.125 11.25C8.125 12.1458 8.42188 12.8906 9.01562 13.4844C9.60938 14.0781 10.3542 14.375 11.25 14.375ZM11.25 16.25C9.52083 16.25 7.98438 15.7865 6.64062 14.8594C5.29688 13.9323 4.33333 12.7292 3.75 11.25C4.33333 9.79167 5.29688 8.59375 6.64062 7.65625C7.98438 6.71875 9.52083 6.25 11.25 6.25C12.9583 6.25 14.4844 6.71875 15.8281 7.65625C17.1719 8.59375 18.1458 9.79167 18.75 11.25C18.1458 12.7292 17.1719 13.9323 15.8281 14.8594C14.4844 15.7865 12.9583 16.25 11.25 16.25ZM23.2188 25L18.25 20.0625C17.2708 20.8333 16.1875 21.4323 15 21.8594C13.8125 22.2865 12.5625 22.5 11.25 22.5C9.6875 22.5 8.22396 22.2031 6.85938 21.6094C5.49479 21.0156 4.30729 20.2135 3.29688 19.2031C2.28646 18.1927 1.48438 17.0052 0.890625 15.6406C0.296875 14.276 0 12.8125 0 11.25C0 9.70833 0.296875 8.25521 0.890625 6.89063C1.48438 5.52604 2.28646 4.33333 3.29688 3.3125C4.30729 2.29167 5.49479 1.48438 6.85938 0.890625C8.22396 0.296875 9.6875 0 11.25 0C12.7917 0 14.2448 0.296875 15.6094 0.890625C16.974 1.48438 18.1667 2.29167 19.1875 3.3125C20.2083 4.33333 21.0156 5.52604 21.6094 6.89063C22.2031 8.25521 22.5 9.70833 22.5 11.25C22.5 12.5833 22.2812 13.8438 21.8438 15.0313C21.4062 16.2188 20.8021 17.3021 20.0312 18.2812L25 23.25L23.2188 25Z"
            fill="currentColor"
          />
        </svg>

        <span class="text-[11px] font-semibold text-[#1C1B1F]">Búsqueda</span>
      </div>

      <!-- Chevron simple -->
      <svg
        class="w-6 h-6 text-[#1C1B1F]"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 6L15 12L9 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <!-- Paso 2: Local (inactivo) -->
      <div
        class="w-[75px] h-[64px] rounded-2xl border border-gray-200 bg-gray-50 flex flex-col items-center justify-center opacity-60"
      >
        <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.5698 0.673828C14.4558 0.673941 17.2259 1.80153 19.27 3.81152C21.3145 5.82199 22.4653 8.55126 22.4653 11.3994C22.4653 13.3545 21.7774 15.4136 20.7964 17.3682C19.8116 19.3302 18.506 21.2367 17.2124 22.8994C15.9172 24.5642 14.6238 25.9984 13.6548 27.0156C13.1701 27.5244 12.7651 27.9298 12.481 28.209C12.339 28.3484 12.2269 28.4567 12.1499 28.5303C12.1116 28.5669 12.0814 28.5951 12.061 28.6143C12.0509 28.6238 12.043 28.6316 12.0376 28.6367C12.0349 28.6393 12.0322 28.6412 12.0308 28.6426L12.0298 28.6445H12.0288L11.5698 29.0732L11.1099 28.6445H11.1089L11.1079 28.6426C11.1064 28.6412 11.1038 28.6393 11.1011 28.6367C11.0957 28.6316 11.0878 28.6238 11.0776 28.6143C11.0573 28.5951 11.028 28.5668 10.9897 28.5303C10.9127 28.4567 10.7998 28.3486 10.6577 28.209C10.3736 27.9299 9.96945 27.5243 9.48486 27.0156C8.51582 25.9984 7.22152 24.5643 5.92627 22.8994C4.63268 21.2367 3.32708 19.3302 2.34229 17.3682C1.36126 15.4136 0.673355 13.3545 0.67334 11.3994C0.67334 8.55128 1.82418 5.82198 3.86865 3.81152C5.91285 1.80143 8.6837 0.673828 11.5698 0.673828Z"
            fill="#BD2520"
            stroke="#BD2520"
            stroke-width="1.34717"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.49046 5.9043L11.5224 8.56496L15.57 5.9043H7.49046ZM4.84399 13.9958V11.0535C4.84399 8.17369 6.2295 7.48504 8.93824 7.48504L11.5224 9.59792L14.2 7.48504C16.9088 7.48504 18.2943 8.15804 18.2943 11.0535V13.9958C18.2943 16.8756 16.6908 17.5643 13.9821 17.5643H9.15618C6.44744 17.5643 4.84399 16.8756 4.84399 13.9958ZM7.92635 11.9925V13.0568C7.92635 14.481 8.22213 15.0288 9.63877 15.0288H13.4839C14.9006 15.0288 15.1964 14.481 15.1964 13.0568V11.9925C15.1964 10.7717 14.9006 10.0205 13.3127 10.0205H9.81002C8.22213 10.0205 7.92635 10.7717 7.92635 11.9925Z"
            fill="white"
          />
        </svg>

        <span class="text-[11px] font-semibold text-gray-500">Local</span>
      </div>

      <!-- Chevron simple -->
      <svg
        class="w-6 h-6 text-[#1C1B1F]"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 6L15 12L9 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <!-- Paso 3: Agenda (inactivo) -->
      <div
        class="w-[75px] h-[64px] rounded-2xl border border-gray-200 bg-gray-50 flex flex-col items-center justify-center opacity-60"
      >
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25.5 0H1.0625C0.474805 0 0 0.474805 0 1.0625V25.5C0 26.0877 0.474805 26.5625 1.0625 26.5625H25.5C26.0877 26.5625 26.5625 26.0877 26.5625 25.5V1.0625C26.5625 0.474805 26.0877 0 25.5 0ZM8.89844 19.3906C8.16465 19.3906 7.57031 18.7963 7.57031 18.0625C7.57031 17.3287 8.16465 16.7344 8.89844 16.7344C9.63223 16.7344 10.2266 17.3287 10.2266 18.0625C10.2266 18.7963 9.63223 19.3906 8.89844 19.3906ZM8.89844 14.6094C8.16465 14.6094 7.57031 14.015 7.57031 13.2812C7.57031 12.5475 8.16465 11.9531 8.89844 11.9531C9.63223 11.9531 10.2266 12.5475 10.2266 13.2812C10.2266 14.015 9.63223 14.6094 8.89844 14.6094ZM8.89844 9.82812C8.16465 9.82812 7.57031 9.23379 7.57031 8.5C7.57031 7.76621 8.16465 7.17188 8.89844 7.17188C9.63223 7.17188 10.2266 7.76621 10.2266 8.5C10.2266 9.23379 9.63223 9.82812 8.89844 9.82812ZM18.9922 18.8594C18.9922 19.0055 18.8727 19.125 18.7266 19.125H12.6172C12.4711 19.125 12.3516 19.0055 12.3516 18.8594V17.2656C12.3516 17.1195 12.4711 17 12.6172 17H18.7266C18.8727 17 18.9922 17.1195 18.9922 17.2656V18.8594Z"
            fill="#CDCDCD"
          />
        </svg>

        <span class="text-[11px] font-semibold text-gray-500">Agenda</span>
      </div>
    </div>

    <!-- Título principal -->
    <div class="flex items-start justify-center gap-2 text-ROJO_LEON font-bold text-base">
      <svg class="w-3 h-3 mt-[6px]" viewBox="0 0 10 6" fill="currentColor" aria-hidden="true">
        <path d="M0 0h10L5 6z" />
      </svg>
      <span>Busca tu lubricante por:</span>
    </div>

    <!-- Tabs -->
    <OpcionesAceites :initialValue="selectedSearchType" @selectedOption="selectedOption" />

    <!-- CONTENIDO SEGÚN MODO -->
    <div class="mt-1">

      <!-- POR AUTO -->
      <div v-show="selectedSearchType === 'por_auto'">
        <AutoSelectorSinVersion @carSelected="onCarSelected" />
      </div>

      <!-- POR TIPO DE ACEITE -->
      <div v-show="selectedSearchType === 'por_aceite'">
        <div class="flex items-start justify-center gap-2 text-ROJO_LEON font-bold text-base mb-3">
          <svg class="w-3 h-3 mt-[6px]" viewBox="0 0 10 6" fill="currentColor" aria-hidden="true">
            <path d="M0 0h10L5 6z" />
          </svg>
          <span>¿Dónde encontrar el tipo de aceite?</span>
        </div>

        <!-- 4 íconos -->
        <div class="grid grid-cols-4 gap-3 text-[11px] text-center text-[#1C1B1F] mb-4">
          <div class="flex flex-col items-center gap-2">
            <img src="/img/aceites/manual_usuario.webp" alt="Manual de usuario" class="w-9 h-9 object-contain" />
            <span class="leading-3 max-w-[78px] font-medium">Manual de usuario</span>
          </div>

          <div class="flex flex-col items-center gap-2">
            <img src="/img/aceites/etiqueta_capot.webp" alt="Etiqueta en el capot" class="w-9 h-9 object-contain" />
            <span class="leading-3 max-w-[78px] font-medium">Etiqueta en el capot</span>
          </div>

          <div class="flex flex-col items-center gap-2">
            <img src="/img/aceites/tapa_aceite.webp" alt="Tapa del aceite" class="w-9 h-9 object-contain" />
            <span class="leading-3 max-w-[78px] font-medium">Tapa del aceite</span>
          </div>

          <div class="flex flex-col items-center gap-2">
            <img
              src="/img/aceites/etiqueta_señalizador.webp"
              alt="Etiqueta en el señalizador"
              class="w-9 h-9 object-contain"
            />
            <span class="leading-3 max-w-[78px] font-medium">Etiqueta en el señalizador</span>
          </div>
        </div>

        <!-- Select -->
        <div class="relative w-full">
          <select
            class="w-full h-12 rounded-xl border-2 border-VERDE_TOP_CALIDAD bg-white px-4 pr-10 text-center text-lg font-medium text-[#1C1B1F] outline-none appearance-none"
            :value="aceiteSeleccionado"
            :disabled="select_deshabilitado"
            @change="onTipoAceiteChange"
          >
            <option value="" disabled>
              {{ select_deshabilitado ? "Cargando opciones..." : "Selecciona un tipo de aceite" }}
            </option>

            <option v-for="opt in aceiteOptions" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

    </div>

    <!-- BOTÓN SIGUIENTE -->
    <div class="flex flex-col items-center mt-2">
      <button
        class="w-[78%] h-12 rounded-xl font-bold text-base bg-VERDE_TOP_CALIDAD text-white disabled:bg-gray-300 disabled:text-gray-700 flex items-center justify-center"
        :disabled="!busqueda_valida"
        @click="handleSearch"
      >
        <span>Siguiente</span>
        <LoaderSvg v-if="isSearching" fillColor="currentFill" sizeClass="w-4 h-4 ml-2" />
      </button>
    </div>

    <!-- AGENDA RÁPIDO AQUÍ -->
    <button
      type="button"
      class="mt-3 flex items-center justify-center gap-2 text-sm underline text-[#1C1B1F]"
      @click="onAgendaRapida"
    >
      <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.95 16.35L4.4 12.8L5.85 11.35L7.95 13.45L12.15 9.25L13.6 10.7L7.95 16.35ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6Z"
          fill="#1C1B1F"
        />
      </svg>

      <span>Agenda rápido aquí</span>
    </button>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import LoaderSvg from "~/components/Ui/LoaderSvg";
import OpcionesAceites from "~/components/Selectores/OpcionesAceites";
import AutoSelectorSinVersion from "~/components/Selectores/AutoSelectorSinVersion";

import { useStore } from "vuex";

const store = useStore();

// Composable validaciones
const { cargarLubricantes } = useAceites();

// Nuxt / Vue
const modo_sistema = useState("modo_sistema");
const router = useRouter();

// =========================
// Props / Emits
// =========================
const props = defineProps({
  category: {
    type: String,
    required: false,
    default: "",
  },

  variant: {
    type: String,
    required: false,
    default: "page", // "page" | "modal"
    validator: (v) => ["page", "modal"].includes(v),
  },

  containerClass: {
    type: String,
    required: false,
    default: "",
  },
});

const emit = defineEmits(["callContact"]);

// =========================
// Estado principal
// =========================
const isSearching = ref(false);
const aceiteSeleccionado = ref("");

// =========================
// Store / Constantes
// =========================
const searchData = computed(() => store.getters["aceites/getSearchData"] || {});

// Normalizamos el modo de búsqueda:
const selectedSearchType = computed(() => {
  const modo = searchData.value.modo_busqueda;

  // legacy y actual backend → UI tipo aceite
  if (modo === "por_patente" || modo === "por_aceite" ) return "por_aceite";

  if (modo === "por_auto") return "por_auto";

  // directo no es un tab; lo tratamos como neutro
  if (modo === "directo") return "por_aceite";

  return "por_aceite";
});

// =========================
// Catálogo SAE (cache Nuxt)
// =========================
const SAE_FALLBACK = ["0W20", "5W30", "10W30", "15W40"];

// Normaliza cualquier ítem a { value, label }
const normalizar_opcion_sae = (item) => {
  if (typeof item === "string") {
    const s = item.trim();
    return s ? { value: s, label: s } : null;
  }

  if (item && typeof item === "object") {
    const candidato =
      item.sae ??
      item.valor ??
      item.value ??
      item.nombre ??
      item.descripcion ??
      item.tipo ??
      null;

    if (candidato === null || candidato === undefined) return null;

    const s = String(candidato).trim();
    return s ? { value: s, label: s } : null;
  }

  return null;
};

const dedupe_por_value = (arr) => {
  const seen = new Set();

  return arr.filter((x) => {
    if (!x?.value) return false;
    if (seen.has(x.value)) return false;

    seen.add(x.value);
    return true;
  });
};

// Cache en memoria (Nuxt), para no pegarle al backend cada vez
const catalogo_sae = useState("aceites_catalogo_sae", () => null);
const cargando_catalogo_sae = ref(false);

const aceiteOptions = computed(() => {
  const lista = Array.isArray(catalogo_sae.value) ? catalogo_sae.value : [];
  const normalizados = dedupe_por_value(lista.map(normalizar_opcion_sae).filter(Boolean));

  if (normalizados.length > 0) return normalizados;

  return SAE_FALLBACK.map((s) => ({ value: s, label: s }));
});

const select_deshabilitado = computed(() => {
  const hay_opciones = Array.isArray(aceiteOptions.value) && aceiteOptions.value.length > 0;
  return cargando_catalogo_sae.value && !hay_opciones;
});

// =========================
// Clases contenedor
// =========================
const clases_contenedor = computed(() => {
  const base = "flex flex-col gap-5 z-30";

  // page
  const page = `
    w-[92%] md:w-[400px]
    mx-auto md:mx-0
    bg-GRIS_CLARO rounded-2xl
    px-6 pt-6 pb-6
    shadow-lg
    static md:absolute right-[13rem] -translate-y-[1rem] md:-translate-y-[36rem]
  `;

  const modal = `
    w-full
    bg-transparent
    rounded-2xl
  `;

  return [base, props.variant === "modal" ? modal : page, props.containerClass].join(" ");
});

// =========================
// Helpers / Validaciones UI
// =========================
const tiene_valor = (v) => v !== "" && v !== null && v !== undefined;

const busqueda_valida = computed(() => {
  if (selectedSearchType.value === "por_auto") {
    return (
      tiene_valor(searchData.value.marca) &&
      tiene_valor(searchData.value.ano) &&
      tiene_valor(searchData.value.modelo)
    );
  }

  if (selectedSearchType.value === "por_aceite") {
    return tiene_valor(aceiteSeleccionado.value);
  }

  return false;
});

// =========================
// Watchers (sincronización)
// =========================
watch(
  () => searchData.value.tipo_aceite,
  (nuevo) => {
    aceiteSeleccionado.value = (nuevo ?? "").toString().trim();
  },
  { immediate: true }
);

watch(
  aceiteOptions,
  (opts) => {
    if (!aceiteSeleccionado.value) return;

    const existe = opts.some((o) => o.value === aceiteSeleccionado.value);
    if (!existe) {
      aceiteSeleccionado.value = "";
      store.commit("aceites/SET_SEARCH_DATA", { tipo_aceite: "" });
    }
  },
  { immediate: true }
);

// =========================
// Mutaciones / Eventos UI
// =========================
const onCarSelected = (carData) => {
  try {
    console.log('[carSelected payload]', carData);
    store.commit("aceites/SET_AUTO_SEARCH", {
      marca: carData?.marca ?? "",
      marca_logo: carData?.marca_logo ?? "",
      ano: carData?.ano ?? "",
      modelo: carData?.modelo ?? "",
      local: "",
    });
  } catch (e) {
    console.error('[onCarSelected] reventó:', e, carData);
  }
};

const onTipoAceiteChange = (event) => {
  const value = event.target.value;
  aceiteSeleccionado.value = value;
  store.commit("aceites/SET_SEARCH_DATA", { tipo_aceite: value });
};

const selectedOption = (value) => {
  const modo_a_guardar = value === "por_aceite" ? "por_patente" : value;

  store.commit("aceites/RESET_INFO_ESPECIFICACIONES");
  store.commit("aceites/RESET_PRODUCTO_SELECCIONADO");
  store.commit("aceites/RESET_DETALLE_AGENDAMIENTO");

  store.commit("aceites/SET_SEARCH_DATA", {
    modo_busqueda: modo_a_guardar,
    flujo_agendamiento: null,
  });
};

// =========================
// Acciones (navegación)
// =========================
const onAgendaRapida = async () => {
  try {
    const negocio = modo_sistema.value || "aceites";
    store.commit("aceites/RESET_SEARCH_DATA");
    console.log('[ANTES DE /local]', {
      searchData: store.getters["aceites/getSearchData"],
      detalle_agendamiento: store.getters["aceites/getDetalleAgendamiento"],
      personal_information: store.getters["aceites/getPersonalInformation"],
      producto_seleccionado: store.getters["aceites/getProductoSeleccionado"],
      storage: {
        searchData: localStorage.getItem('aceites_searchData'),
        detalle: localStorage.getItem('aceites_detalle_agendamiento'),
        personal: localStorage.getItem('aceites_personal_information'),
        producto: localStorage.getItem('aceites_producto_seleccionado'),
      }
    });
    await router.push(`/${negocio}/local`);
  } catch (error) {
    console.error("[FormularioAceite] Error redirigiendo a /aceites/local:", error);
  }
};


const handleSearch = async () => {
  try {
    isSearching.value = true;

    let targetRoute = "/local";

    if (selectedSearchType.value === "por_auto") {
      const vehiculoData = {
        marca: searchData.value.marca,
        ano: searchData.value.ano,
        modelo: searchData.value.modelo,
      };

      if (!vehiculoData.marca || !vehiculoData.ano || !vehiculoData.modelo) {
        throw new Error("Datos de vehículo incompletos");
      }

      store.commit("aceites/SET_AUTO_SEARCH", {
        marca: searchData.value.marca,
        marca_logo: searchData.value.marca_logo,
        ano: searchData.value.ano,
        modelo: searchData.value.modelo,
        local: '',
      });
    } else if (selectedSearchType.value === "por_aceite") {
      if (!aceiteSeleccionado.value) {
        throw new Error("Debes seleccionar un tipo de aceite");
      }

      store.commit("aceites/SET_ACEITE_SEARCH", {
        local: '',
        tipo_aceite: aceiteSeleccionado.value,
      });

      targetRoute = "/local";
    }

    // FIX: fallback si modo_sistema viene vacío
    const negocio = modo_sistema.value || "aceites";
    await router.push(`/${negocio}${targetRoute}`);
  } catch (error) {
    console.error("Error en búsqueda:", error);
    alert("Error al procesar la búsqueda. Intenta nuevamente.");
  } finally {
    isSearching.value = false;
  }
};

// =========================
// Lifecycle
// =========================
onMounted(async () => {
  //console.log("onMounted components/Formularios/FormularioAceite.vue")
  store.commit("aceites/LOAD_FROM_STORAGE");

  if (store.getters["aceites/getSearchData"]?.modo_busqueda === "por_patente") {
    store.commit("aceites/SET_SEARCH_DATA", { modo_busqueda: "por_aceite" });
  }

  if (Array.isArray(catalogo_sae.value) && catalogo_sae.value.length > 0) return;

  cargando_catalogo_sae.value = true;

  try {
    const lista = await cargarLubricantes();
    if (Array.isArray(lista) && lista.length > 0) {
      catalogo_sae.value = lista;
    }
  } catch (e) {
    console.error("[FormularioAceite] No se pudo cargar catálogo SAE:", e);
    catalogo_sae.value = null;
  } finally {
    cargando_catalogo_sae.value = false;
  }
});
</script>

<style scoped>
.boton_buscar:disabled {
  background-color: rgb(209 209 209);
  color: black;
}
</style>